import * as Yup from 'yup';
import {messages} from '../../../common/Models/Validations';
import { visitorTypes } from '../../../services/TicketsServices';

export const museumInitialValue = {
  dzongkhag_id: null,
  gewog_id: null,
  museum_type_id: null,
  date_of_establishment: '',
  photo_ids: [],
  agency_code: '',
  translations: {
    en: {
      name: '',
      description: ''
    },
    dz: {
      name: '',
      description: ''
    }
  },
  tenant_code: null,
  counter_code: '',
  office_code: null,
  services: [{
    code: '',
    name: '',
    service_type: '',
    description: ''
  }]
};

export const museumValidation = Yup.object().shape({
  dzongkhag_id: Yup.mixed().required(messages.required),
  gewog_id: Yup.mixed().required(messages.required),
  museum_type_id: Yup.mixed().required(messages.required),
  date_of_establishment: Yup.string().required(messages.required),
  photo_ids: Yup.array().min(1, 'At least one photo is required').required(messages.required),
  agency_code: Yup.string().required(messages.required),
  translations: Yup.object().shape({
    en: Yup.object().shape({
      name: Yup.string().matches(/^[a-zA-Z ]+$/, 'Accept text only').required(messages.required),
      description: Yup.string().required(messages.required)
    }),
    dz: Yup.object().shape({
      name: Yup.string().required(messages.required),
      description: Yup.string().required(messages.required)
    })
  }),
  tenant_code: Yup.mixed().required(messages.required),
  counter_code: Yup.string().required(messages.required),
  office_code: Yup.mixed().required(messages.required),
  services: Yup.array().of(
    Yup.object().shape({
      code: Yup.string().required(messages.required),
      name: Yup.string().required(messages.required),
      service_type: Yup.string().required(messages.required), // make sure to use code of visitor_type
      description: Yup.string().required(messages.required)
    })
  ).min(1, 'At least one service is required')
});

// Utility function to fetch visitor types for dropdown
export const getVisitorTypesForDropdown = async () => {
  try {
    const response = await visitorTypes('get', null, { per_page: 100 });
    return response?.data?.map(visitor => ({
      value: visitor.code,
      label: visitor?.translations?.en?.name || visitor.name,
      code: visitor.code
    })) || [];
  } catch (error) {
    console.error('Failed to fetch visitor types:', error);
    return [];
  }
};
